import React from "react";
import ReactDOM from "react-dom/client";
import AiProductivity from "./ai-productivity";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AiProductivity />
  </React.StrictMode>,
);
